/**
 * ChannelsChoice component.
 */
import ChannelsChoiceTemplate from '../templates/channelsChoice';

export default function ChannelsChoicePage() {
  return <ChannelsChoiceTemplate />;
}
